// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1l9vR","content":"ManualTimeModal_content__3JrYE"};